import React, { useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableCell,
  TableRow,
  TitleCell,
} from "./Fans.style";
import MainLayout from "../../components/Layouts/Main/MainLayout.index";
import { useNavigate } from "react-router-dom";
import { getUserFans } from "../../api/project";
import * as XLSX from "xlsx";

const Fans = () => {
  const [infoList, setInfoList] = useState([]);
  const [filterUserName, setFilterUserName] = useState("");
  const [filterKanaSearchKeyWord, setFilterKanaSearchKeyWord] = useState("");
  const [filterFanName, setFilterFanName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/");
      return;
    }
    const getInfos = async () => {
      setLoading(true);
      try {
        const res = await getUserFans();
        if (res.code === 200 && res.data.length > 0) {
          setInfoList(res.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getInfos();
  }, [navigate]);

  const filteredList = infoList
    .map((item) => {
      const matchUserName = item.user_name.includes(filterUserName);
      const filteredFans = item.fansList.filter((fan) =>
        fan.fanName.includes(filterFanName),
      );
      return matchUserName && filteredFans.length > 0
        ? { ...item, fansList: filteredFans }
        : null;
    })
    .filter(Boolean);

  const totalPages = Math.ceil(filteredList.length / pageSize);
  const paginatedList = filteredList.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [filterUserName, filterFanName]);

  const exportToExcel = () => {
    const data = filteredList.flatMap((item) =>
      item.fansList.map((fan) => ({
        "プロ／ゲスト": item.user_name,
        "カナ／検索キーワード": item.userKana + "／" + item.searchKeyword,
        ファン名: fan.fanName,
      })),
    );

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "お気に入り一覧");
    XLSX.writeFile(workbook, "お気に入り一覧.xlsx");
  };

  const handleClear = () => {
    setFilterUserName("");
    setFilterFanName("");
  };

  const totalFans = infoList.reduce(
    (acc, item) => acc + item.fansList.length,
    0,
  );
  const filteredFans = filteredList.reduce(
    (acc, item) => acc + item.fansList.length,
    0,
  );

  return (
    <MainLayout>
      {loading ? (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "50px",
          fontSize: "16px"
        }}>
          <div style={{
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #008000",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            animation: "spin 1s linear infinite",
            marginRight: "10px"
          }} />
          読み込み中...
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      ) : (
        <>
      <div
        style={{ marginBottom: "10px", textAlign: "left", color: "#008000" }}
      >
        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
          ファン-お気に入り一覧
        </span>
      </div>
      {/* 絞り込み条件 */}
      <div
        style={{
          marginBottom: "10px",
          textAlign: "left",
          color: "#666",
          fontStyle: "italic",
        }}
      >
        <span style={{ fontSize: "13px", fontWeight: "normal" }}>
          絞り込み条件
        </span>
      </div>

      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          justifyContent: "flex-start",
          gap: "10px",
        }}
      >
        <input
          type="text"
          placeholder="プロ名"
          value={filterUserName}
          onChange={(e) => setFilterUserName(e.target.value)}
        />
        <input
          type="text"
          placeholder="カナ／検索キーワード"
          value={filterKanaSearchKeyWord}
          onChange={(e) => setFilterKanaSearchKeyWord(e.target.value)}
        />
        <input
          type="text"
          placeholder="ファン名"
          value={filterFanName}
          onChange={(e) => setFilterFanName(e.target.value)}
        />
        <button onClick={handleClear}>クリア</button>
        <button onClick={exportToExcel}>Excel出力</button>
      </div>

      {/* プロ／ゲスト+ファン一覧 */}
      <div
        style={{
          marginBottom: "0.1px",
          textAlign: "left",
          color: "#666",
          fontStyle: "italic",
        }}
      >
        <span style={{ fontSize: "13px", fontWeight: "normal" }}>
          プロ／ゲスト+ファン一覧 📊 全データ：{totalFans} 件 ／
          フィルター結果：{filteredFans} 件
        </span>
      </div>

      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        padding: "20px",
        flexWrap: "wrap"
      }}>
        <button
          onClick={() => setCurrentPage(1)}
          disabled={currentPage === 1}
        >最初</button>
        <button
          onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
          disabled={currentPage === 1}
        >前へ</button>
        <span>
          {currentPage} / {totalPages} ページ
          （全{filteredList.length}件中 {paginatedList.length}件表示）
        </span>
        <button
          onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
          disabled={currentPage === totalPages}
        >次へ</button>
        <button
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
        >最後</button>
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value={50}>50件</option>
          <option value={100}>100件</option>
          <option value={200}>200件</option>
          <option value={500}>500件</option>
        </select>
      </div>
      <Table>
        <thead>
          <tr>
            <TableHeader>プロ／ゲスト</TableHeader>
            <TableHeader>カナ／検索キーワード</TableHeader>
            <TableHeader>ファン名</TableHeader>
          </tr>
        </thead>
        <tbody>
          {paginatedList.map((item, index) => (
            <React.Fragment key={index}>
              <TableRow>
                <TableCell rowSpan={item.fansList.length + 1}>
                  {item.user_name}
                </TableCell>
                <TableCell rowSpan={item.fansList.length + 1}>
                  {item.userKana + "／" + item.searchKeyword}
                </TableCell>
              </TableRow>
              {item.fansList.map((fans, fansIndex) => (
                <TableRow key={`${index}-${fansIndex}`}>
                  <TitleCell>{fans.fanName}</TitleCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        padding: "20px",
        flexWrap: "wrap"
      }}>
        <button
          onClick={() => setCurrentPage(1)}
          disabled={currentPage === 1}
        >最初</button>
        <button
          onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
          disabled={currentPage === 1}
        >前へ</button>
        <span>
          {currentPage} / {totalPages} ページ
          （全{filteredList.length}件中 {paginatedList.length}件表示）
        </span>
        <button
          onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
          disabled={currentPage === totalPages}
        >次へ</button>
        <button
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
        >最後</button>
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value={50}>50件</option>
          <option value={100}>100件</option>
          <option value={200}>200件</option>
          <option value={500}>500件</option>
        </select>
      </div>
      </>
      )}
    </MainLayout>
  );
};

export default Fans;
